module.exports = __webpack_public_path__ + "images/videoCaseStudy-nivea-challenge-videoPoster.jpg?h=6549df1d4adac477f2b931410680f6d0";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-challenge-videoPoster.jpg
// module id = 2112
// module chunks = 12 15